import React from 'react';

import { fromNow } from '@common/react/utils/timeUtils';
import { useModal } from '@common/react/components/Modal/ModalContextProvider';

import { Review } from '@app/objects/Review';
import Stars from '@app/components/UI/Stars/Stars';

interface ReviewModalProps {
	review: Review;
	buttonClassName?: string;
}

const ReviewModal: React.FC<ReviewModalProps> = ({ review, buttonClassName }) => {
	const [visible, setVisible] = React.useState<boolean>(false);
	const { renderModal } = useModal();

	const close = () => setVisible(false);

	const open = () => setVisible(true);

	if (!review) return <> </>;

	return (
		<>
			<button type="button" onClick={open} className={`btn ${buttonClassName || ''}`}>
				My Review
			</button>
			{renderModal(visible, close, {
				title: `Review${review.titleEn ? ` - ${review.titleEn}` : ''}`,
				footer: null,
				width: 'min(600px, 800vw)',
				children: <div key={review.id} className="review mb10">
					<div className="reviews-title">
						<div className="stars pull-left">
							<Stars value={review.rate} />
							<Stars value={5 - Math.round(review.rate)} className="star-disabled" />
						</div>
						<div className="pull-right">
							<strong className="mr10">{fromNow(review.time)}</strong>
						</div>
					</div>
					<br />
					<p>{review.textEn}</p>
				</div>,
				className: 'location-popap',
			})}
		</>
	);
};

export default ReviewModal;
